export default "__VITE_ASSET__BqTJIJKy__"